// pt-PT source of truth for the people/collaborator area. English mirrors this
// exact shape in ../en/people.ts. Grouped by page: list, record, deleted,
// profile, similar.
export const people = {
  list: {
    title: 'Colaboradores',
    countOne: '{n} colaborador',
    countMany: '{n} colaboradores',
    syncTitle: 'Puxar os colaboradores do SISTRADE',
    sync: 'Sincronizar Dados',
    syncing: 'A sincronizar…',
    deleted: 'Eliminados',
    new: 'Novo colaborador',
    syncDone:
      'Sincronização concluída: {total} colaboradores ({created} criados, {updated} atualizados).',
    syncFailed: 'A sincronização falhou: {error}.',
    unknownError: 'erro desconhecido',
    newNamePlaceholder: 'Nome completo do colaborador',
    create: 'Criar',
    filterByStatus: 'Filtrar por estado',
    statusActive: 'Ativos',
    statusAll: 'Todos',
    statusInactive: 'Inativos',
    missingTitle: 'Mostrar só colaboradores com campos obrigatórios por preencher',
    missing: 'Dados em falta',
    hideExternalTitle: 'Ocultar colaboradores externos (por defeito são mostrados)',
    hideExternal: 'Sem externos',
    clearFilters: 'Limpar filtros',
    searchPlaceholder: 'Pesquisar por nome, código, departamento…',
    empty: 'Sem resultados para a pesquisa.',
    col: {
      code: 'Código',
      name: 'Nome',
      department: 'Departamento',
      situation: 'Situação',
      contractStart: 'Início contrato',
      contractEnd: 'Fim contrato',
      dedication: '% Ded.',
      state: 'Estado',
    },
    missDotTitle: 'Tem campos obrigatórios por preencher',
    missDotAria: 'Dados obrigatórios em falta',
    external: 'Externo',
    showing: 'A mostrar {visible} de {total}…',
    flag: {
      expired: 'Expirado',
      lt1: '< 1 mês',
      lt3: '< 3 meses',
      lt6: '< 6 meses',
    },
    dept: {
      label: 'Departamento',
      filterPlaceholder: 'Filtrar departamentos…',
      clear: 'Limpar seleção ({n})',
      empty: 'Sem departamentos',
    },
  },
  record: {
    notFound: 'Colaborador não encontrado.',
    back: '← Colaboradores',
    history: 'Histórico',
    deleteTitle: 'Eliminar o colaborador (apenas nas primeiras 72h)',
    saving: 'A guardar…',
    saved: 'Guardado.',
    missingRequired: 'Faltam {n} campo(s) obrigatório(s):',
    emptySection: 'Sem campos nesta secção.',
    empty: '(vazio)',
    reserved: 'reservado',
    statusAria: 'Situação',
    deleteConfirm:
      'Eliminar o colaborador "{name}"?\n\nSó é possível nas primeiras 72 horas após a criação. O registo fica numa lixeira acessível apenas a administradores, que o podem repor.',
    field: {
      code: 'Código',
      fullName: 'Nome',
      shortName: 'Abreviatura',
      personalEmail: 'Email Pessoal',
      professionalEmail: 'Email Profissional',
      orcid: 'ORCID',
      cienciaId: 'CIÊNCIA ID',
      scopusAuthorId: 'SCOPUS AUTHOR ID',
      situacao: 'Situação Colaborador',
    },
    hist: {
      title: 'Histórico de alterações',
      noHistory: 'Sem alterações registadas.',
      date: 'Data',
      field: 'Campo',
      from: 'De',
      to: 'Para',
      source: 'Origem',
      manual: 'Manual',
    },
    confirmLeave: {
      title: 'Alterações por guardar',
      body: 'Tens alterações nesta ficha que ainda não foram guardadas:',
      discard: 'Descartar',
      save: 'Guardar alterações',
    },
  },
  deleted: {
    title: 'Colaboradores eliminados',
    subtitle: 'Lixeira — registos eliminados que podem ser repostos',
    back: '← Colaboradores',
    adminOnly: 'Esta área é reservada a administradores do portal.',
    empty: 'Sem registos eliminados.',
    restore: 'Repor',
    col: {
      code: 'Código',
      name: 'Nome',
      state: 'Estado',
      created: 'Criado',
      deleted: 'Eliminado',
      by: 'Por',
    },
  },
  profile: {
    title: 'Meu Perfil',
    noFicha: {
      before:
        'A tua conta ainda não está associada a uma ficha de colaborador. A ligação é feita pelo campo ',
      after:
        ' da ficha (ou pelo email profissional). Pede ao Onboarding ou RH para preencher esse campo com o teu utilizador.',
    },
  },
  similar: {
    one: '1 nome semelhante',
    many: '{n} nomes semelhantes',
    heading: 'Colaboradores com nome idêntico ou semelhante',
  },
};
